import React from 'react';
import {Button} from "react-materialize";
import UnderwriterRateForm from "../../forms/UnderwriterRateForm";
import * as creationActions from "../../../actions/creation";
import * as underwriterRateActions from "../../../actions/underwriterRate";
import Dialog from "react-toolbox/lib/dialog/Dialog";

export default class RateItem extends React.Component {
    constructor(props){
        super(props);
        this.state = {
            dialogActive: false
        };
    }
    handleDelete = () => {
        this.props.dispatch(underwriterRateActions.deleteUnderwriterrate(this.props.item.id));
    };
    render() {
        return (
            <tr>
                <td>{this.props.item.name}</td>
                <td>{this.props.item.rate}</td>
                <td>{this.props.item.yearOfAddition}</td>
                <td>
                    <Button type="button" floating onClick={() => this.props.openDrawer(UnderwriterRateForm, {item: this.props.item, underwriter: this.props.underwriter.item}, creationActions.destroyingnewlyCreatedUnderwriter())} icon="edit" className="edit-button small"/>
                    <Button disabled={this.props.deletingUnderwriterrate} floating onClick={()=> this.setState({dialogActive: true})} icon="delete" className="delete-button btn btn-floating underwriter-rate-button"/>
                </td>
                <Dialog
                    actions={[
                        { label: "Cancel", onClick: () => this.setState({...this.state, dialogActive: false}) },
                        { label: "Yes", onClick: () => {this.handleDelete(); this.setState({dialogActive:false}); }}
                    ]}
                    active={this.state.dialogActive}
                    title='Confirmation'>
                    <p>Are you sure you want to delete this rate ?</p>
                </Dialog>
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/underwriter/rates/RateItem.js